module.exports = __webpack_public_path__ + "static/media/number_line_axis.ff698510.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/number_line_axis.svg
// module id = 1404
// module chunks = 0